import {CalculadoraPrecoSabor} from "./SaborPizzaLoja";
import {ObjetoComAdicionais} from "./ObjetoComAdicionais";
import {EstadoRodizioLoja} from "./EstadoRodizioLoja";

import {RegrasDeKit} from "../../../../server/domain/kit/RegrasDeKit";

const PESO = 'Peso'

export class ItemPedido extends ObjetoComAdicionais {
  qtdeUnidadesKit: number;
  get componentesKit(): any[] { return this.adicionais?.componentesKit || []; }
  set componentesKit(valor: any[]) { this.adicionais = this.adicionais || {}; this.adicionais.componentesKit = valor; }
  get erroKit(): string { return RegrasDeKit.erroDoItemTela(this)?.mensagem || ""; }
  total: number;
  valorUnitario: number;
  valorResgatado: number;
  adicionais: any;
  produtoTamanho: any;
  sabores = [];
  guid: string;
  qtdeSabores: number;
  brinde: any;
  opcoes: any[] = [];
  quantidadeParaPrecoAtacado: number;

  constructor(public produto: any, public qtde: number,
              public observacao: string) {
    super();
    this.adicionais = {}
    this.valorUnitario = produto?.preco || 0;
    if(produto && produto.brinde)
      this.brinde = true;
    try{
      this.guid =  (crypto as any).randomUUID();
    } catch (e) {
      this.guid = new Date().getTime().toString()
    }
    this.atualizeTotal();
  }

  atualize(qtde, observacao: string, adicionais: any, tamanho: any , sabores: any){
    this.qtde = qtde;
    this.produtoTamanho = tamanho;
    this.sabores = sabores || [];

    this.observacao = observacao

    this.adicionais = adicionais
    this.atualizeTotal()
  }


  atualizeTotal() {
    if(this.produto && this.brinde){
      this.valorUnitario = 0;
      this.total = 0;
      this.valorResgatado = this.produto.valorResgate * this.qtde;
    } else {
      this.valorUnitario = this.obtenhaValorUnitario();
      this.total = this.obtenhaValor();
    }
  }

  obtenhaValor(): number {
    const detalhesAdicionais = this.obtenhaDetalhesValorAdicionais();
    const valorBase = this.obtenhaPreco();

    if(this.produto.tipoDeVenda  && this.produto.tipoDeVenda === PESO)
      return this.obtenhaValorPorPeso();

    if (this.componentesKit.length) return Number((Number((valorBase + detalhesAdicionais.multiplicados).toFixed(2)) * this.qtde + detalhesAdicionais.independentes).toFixed(2));
    return Number(((valorBase * this.qtde) + (detalhesAdicionais.multiplicados * this.qtde) + detalhesAdicionais.independentes).toFixed(2));
  }

  temPrecoAntigo(): boolean {
    return this.obtenhaPrecoAntigo() != null;
  }

  obtenhaTotalPrecoAntigo(): number {
    const precoAntigo = this.obtenhaPrecoAntigo();
    if(precoAntigo == null)
      return this.total;

    const detalhesAdicionais = this.obtenhaDetalhesValorAdicionais();

    if(this.produto.tipoDeVenda  && this.produto.tipoDeVenda === PESO)
      return Number(((precoAntigo * this.obtenhaQtdePorPeso()) + detalhesAdicionais.total).toFixed(2));

    return Number(((precoAntigo * this.qtde) + (detalhesAdicionais.multiplicados * this.qtde) + detalhesAdicionais.independentes).toFixed(2));
  }

  obtenhaValorUnitario(): number {
    if(this.produto.tipoDeVenda  && this.produto.tipoDeVenda === PESO)
      return this.obtenhaValorPorPeso();

    const detalhesAdicionais = this.obtenhaDetalhesValorAdicionais();

    return Number((this.obtenhaPreco() + detalhesAdicionais.multiplicados).toFixed(2));
  }

  obtenhaPontosFidelidade(atividade: any){
    if(atividade.cashback != null){//ativiade que determina sera chashback ou pontos
      let preco = this.total, cashback = atividade.cashback;

      if(this.produtoTamanho && this.produtoTamanho.template){
        if(this.produtoTamanho.template.cashback != null)
          cashback = (this.produtoTamanho.template.cashback / 100)
      } else  if(this.produto.cashback != null){
        cashback = (this.produto.cashback / 100)
      }

      let pontos = cashback  * preco;

      return Number(pontos.toFixed(2))
    }

    let pontosPorProduto =    ( atividade.pontosGanhos || 0);

    if(this.produtoTamanho && this.produtoTamanho.template ){
      if(this.produtoTamanho.template.pontosGanhos != null)
        pontosPorProduto = this.produtoTamanho.template.pontosGanhos
    } else if(this.produto.pontosGanhos != null)
      pontosPorProduto = this.produto.pontosGanhos

    return pontosPorProduto * this.qtde;
  }

  private obtenhaPreco(){
    // incluído no rodízio da mesa: produto base sem preço, adicional pago continua (o servidor cobra igual)
    if (EstadoRodizioLoja.produtoIncluido(this.produto)) return 0;
    if (this.produto?.tipo === 'kit') return RegrasDeKit.precoBase(this.produto, this.qtdeUnidadesKit, this.produtoTamanho, this.componentesKit);
    if(this.sabores && this.sabores.length)
       return  CalculadoraPrecoSabor.calculeValorSabores(this.produto.template, this.sabores);

    if(this.produtoTamanho)
      return this.obtenhaPrecoComAtacado(this.produtoTamanho, this.produtoTamanho.preco);

    const precoProduto = this.produto.novoPreco || this.produto.preco;
    return this.obtenhaPrecoComAtacado(this.produto, precoProduto);
  }

  private obtenhaPrecoAntigo(): number {
    if(this.sabores && this.sabores.length)
      return null;

    const alvo = this.produtoTamanho || this.produto;
    const precoAntigo = alvo?.precoAntigo;

    if(precoAntigo == null)
      return null;

    const precoAntigoNormalizado = Number(precoAntigo);
    if(isNaN(precoAntigoNormalizado) || precoAntigoNormalizado <= this.obtenhaPreco())
      return null;

    return precoAntigoNormalizado;
  }

  private obtenhaPrecoComAtacado(alvo: any, precoPadrao: number): number {
    const precoAtacado = alvo?.precoAtacado != null ? alvo.precoAtacado : alvo?.valorAtacado;
    const quantidadeMinima = Number(alvo?.quantidadeMinimaAtacado || 0);

    if(precoAtacado != null && quantidadeMinima > 0 && this.obtenhaQuantidadeParaPrecoAtacado() >= quantidadeMinima)
      return Number(precoAtacado);

    return precoPadrao || 0;
  }

  private obtenhaQuantidadeParaPrecoAtacado(): number {
    return Number(this.quantidadeParaPrecoAtacado || this.qtde || 0);
  }

  private podeMultiplicarQuantidadeDoProduto(meta: any): boolean {
    return meta?.multiplicaQuantidadeProduto !== false;
  }

  private obtenhaDetalhesValorAdicionais(): { multiplicados: number; independentes: number; total: number } {
    let multiplicados = 0;
    let independentes = 0;

    for (let prop in this.adicionais) {
      if(prop.startsWith('meta_')) continue;

      if(prop.startsWith('campo') && this.adicionais[prop] != null) {
        const meta = this.adicionais['meta_' + prop];
        const valor = Number(this.obtenhaPrecoComAtacado(this.adicionais[prop], this.adicionais[prop].valor || 0));

        if(this.podeMultiplicarQuantidadeDoProduto(meta))
          multiplicados += valor;
        else
          independentes += valor;
      }
      else if(prop.startsWith('lista')) {
        let opcoes = this.adicionais[prop]
        let valorBase = this.obtenhaValorAdicional(opcoes)

        if(this.podeMultiplicarQuantidadeDoProduto(opcoes))
          multiplicados += valorBase
        else
          independentes += valorBase
      }
    }

    return {
      multiplicados: Number(multiplicados.toFixed(2)),
      independentes: Number(independentes.toFixed(2)),
      total: Number((multiplicados + independentes).toFixed(2))
    };
  }

  obtenhaValorAdicionais() {
    return this.obtenhaDetalhesValorAdicionais().total;
  }

  obtenhaValorPorPeso(): number{
    let qtdePorPeso = this.obtenhaQtdePorPeso();

    let valorDoPeso = Number((this.obtenhaPreco() * qtdePorPeso ).toFixed(2));

    //quando for por peso adicionais e calculado a parte
    return Number((valorDoPeso + this.obtenhaValorAdicionais()).toFixed(2));
  }

  private obtenhaQtdePorPeso(): number {
    if(this.produto.unidadeMedida && this.produto.unidadeMedida.sigla === 'g')
      return this.qtde / 1000;

    return this.qtde;
  }

  obtenhaDescricao(){
    let descricao = this.produto.nome;

    if(this.produtoTamanho){
      descricao = String(`${this.produto.nome} ${this.produtoTamanho.descricao}`);

      if(this.sabores && this.sabores.length){
        let listaSabores = this.sabores.map( (sabor: any) => sabor.nome);

        if(listaSabores.length   === 1)
          descricao = String(`${this.produto.template.identificador} ${this.produtoTamanho.descricao}  - ${listaSabores[0]}`);
        else{
          for(let i = 0 ; i < listaSabores.length; i++){
            listaSabores[i] = String(`${(i + 1)}°: ${listaSabores[i]}`)
          }
          descricao = String(`${this.produto.template.identificador} ${this.produtoTamanho.descricao} ${this.sabores.length} Sabores ( ${listaSabores.join('; ') } )`);
        }


      }
    }

    return descricao;
  }

  obtenhaUnidade(){
    if(this.produto.tipoDeVenda && this.produto.tipoDeVenda === PESO)
      return this.produto.unidadeMedida.sigla.toLowerCase() + " de ";

    return 'x'
  }

  temOpcaoSelecionada(campo: any, opcao: any): boolean {
    if (!this.opcoes) {
      return false;
    }
    
    return this.opcoes.some(op => 
      op.campoAdicional && op.campoAdicional.id === campo.id && 
      op.opcao && op.opcao.id === opcao.id
    );
  }
}
